export default "__VITE_ASSET__CnsmaUBG__"